// extracted by mini-css-extract-plugin
export default {"table-container":"bWKlCs9oC6ZJL697Nseb","table-top-right-field":"gfw5H32puyJHHtXtJh8x","table-wrapper":"i2aXu4EXuYZLB2hfLeH2"};